var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAfterSales(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1583_8109)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.2192 12.856C34.2192 12.856 34.381 12.8021 34.4709 12.7661C34.2371 12.5143 33.9674 12.2986 33.6797 12.1187L21.3256 5.05153C20.7861 4.74583 20.1747 4.58398 19.5633 4.58398C18.9519 4.58398 18.3405 4.74583 17.801 5.05153L12.4961 8.07262L27.4757 16.7043L34.2371 12.82L34.2192 12.856Z",
    fill: "#111318"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.81613 9.61914L5.42836 12.1367C5.12266 12.3165 4.85292 12.5503 4.61914 12.8021C4.67309 12.8201 4.74502 12.8201 4.79897 12.856L19.5088 21.3079L24.8137 18.2688L9.81613 9.61914Z",
    fill: "#111318"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.66602 29.2925C3.66602 29.9039 3.82786 30.5153 4.13357 31.0548C4.43927 31.5943 4.88884 32.0439 5.42832 32.3496L17.7824 39.4168C17.9083 39.4887 18.0522 39.5247 18.178 39.5786V23.592L3.66602 15.248V29.2925Z",
    fill: "#111318"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4817 23.5733C34.165 23.5733 34.8124 23.6452 35.4418 23.7891V15.1934L20.8398 23.5733V39.5958C21.0017 39.5239 21.1635 39.4879 21.3254 39.398L25.2816 37.1502C24.6162 35.8554 24.1846 34.4168 24.1846 32.8703C24.1846 27.7453 28.3566 23.5733 33.4817 23.5733Z",
    fill: "#111318"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4803 39.7223C37.2642 39.7223 40.3317 36.6549 40.3317 32.8709C40.3317 29.087 37.2642 26.0195 33.4803 26.0195C29.6964 26.0195 26.6289 29.087 26.6289 32.8709C26.6289 36.6549 29.6964 39.7223 33.4803 39.7223Z",
    fill: "#111318"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.5281 29.3632C37.7618 29.561 37.7978 29.9027 37.6 30.1364L32.421 36.3045C32.3131 36.4304 32.1692 36.5023 32.0074 36.5023C31.8455 36.5023 31.7017 36.4304 31.5938 36.3225L29.3819 33.8588C29.1841 33.6251 29.2021 33.2834 29.4179 33.0676C29.6517 32.8698 29.9933 32.8878 30.2091 33.1036L32.0074 35.0997L36.7728 29.4171C36.9706 29.1834 37.3123 29.1474 37.5461 29.3452L37.5281 29.3632Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1583_8109"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAfterSales);
export default __webpack_public_path__ + "static/media/afterSales.3988910203b882cb53a1b320ce17b1ce.svg";
export { ForwardRef as ReactComponent };